import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Userpilot } from 'userpilot';

@Injectable()
export class LoginGuard  {
  constructor(private router: Router, private authService: AuthService) {
  }

  canActivate() {
    const maintenance = localStorage.getItem('maintenance');
    if (this.authService.isLoggedIn()) {
      if (maintenance === 'true') {
        this.router.navigate(['/maintenance']);
        return false;
      }
      Userpilot.reload();
      return true;
    }
    return false;
  }
}
